var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('MembershipHero'),_c('MembershipEngage'),_c('MembershipOnboarding'),_c('MembershipListen'),_c('MembershipSupport'),_c('RequestDemo',{attrs:{"msg":"Simplify membership management and boost engagement."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }